var _filter, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 380,
    height: 70,
    viewBox: "0 0 380 70",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "modern-shadow",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 3,
    in: "SourceAlpha",
    result: "offset"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "offset",
    stdDeviation: 1.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000000",
    floodOpacity: 0.2,
    result: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color",
    in2: "blur",
    result: "shadow"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "over",
    in: "SourceGraphic",
    in2: "shadow"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "frame-shine",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#000000",
      stopOpacity: 0.05
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2, 35)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: -28,
    width: 205,
    height: 56,
    stroke: "#000000",
    strokeWidth: 3,
    fill: "none"
  }), /*#__PURE__*/React.createElement("text", {
    x: 102,
    y: 13,
    textAnchor: "middle",
    fontFamily: "'Helvetica Neue', Helvetica, Arial, sans-serif",
    fontSize: 38,
    fontWeight: 900,
    letterSpacing: 2,
    fill: "#000000"
  }, "\n      GASTRO\n    "), /*#__PURE__*/React.createElement("text", {
    x: 295,
    y: 13,
    textAnchor: "middle",
    fontFamily: "'Helvetica Neue', Helvetica, Arial, sans-serif",
    fontSize: 38,
    fontWeight: 700,
    letterSpacing: 3,
    fill: "#000000"
  }, "\n      EMPIRE\n    "), /*#__PURE__*/React.createElement("g", {
    transform: "translate(311, -23) scale(0.8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-16 8                C-16 8 -14 6 -12 6                L12 6                C14 6 16 8 16 8                                M-12 6                L-14 -2                L-8 2                L-4 -6                L0 0                L4 -6                L8 2                L14 -2                L12 6                                M-14 -2                C-14 -2 -12 -4 -10 -4                M-4 -6                C-4 -6 -2 -8 0 -8                M4 -6                C4 -6 6 -8 8 -8                M14 -2                C14 -2 12 -4 10 -4",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -8,
    cy: 2,
    r: 2,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 2,
    r: 2,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-10 -4 L-8 -8 L-6 -4 M-2 -8 L0 -12 L2 -8 M6 -4 L8 -8 L10 -4",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f2b61c33cb290f351e6583b1c74cc70f.svg";
export { ForwardRef as ReactComponent };